import { Button } from "@/components/ui/button";
import { RefreshCw, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

interface UpdateBannerProps {
  visible: boolean;
  onUpdate: () => void;
}

export function UpdateBanner({ visible, onUpdate }: UpdateBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (!visible || dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -40 }}
        className="fixed top-0 left-0 right-0 z-[100] bg-primary text-primary-foreground px-4 py-2.5"
      >
        <div className="max-w-2xl mx-auto flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-sm font-medium">
            <RefreshCw className="w-4 h-4" />
            <span>A new version of ilajly is available</span>
          </div>
          <div className="flex items-center gap-2">
            <Button
              size="sm"
              variant="secondary"
              onClick={onUpdate}
              className="h-7 text-xs font-semibold"
            >
              Update Now
            </Button>
            <button
              onClick={() => setDismissed(true)}
              className="p-1 hover:bg-primary-foreground/10 rounded"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
